import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastMessage } from '../components/custom-toast/custom-toast.component';

@Injectable({
  providedIn: 'root'
})
export class CustomToastService {
  private toastsSubject = new BehaviorSubject<ToastMessage[]>([]);
  public toasts$: Observable<ToastMessage[]> = this.toastsSubject.asObservable();

  private toastIdCounter = 0;

  show(type: 'success' | 'danger' | 'warning' | 'info' | 'default', message: string, title?: string, duration: number = 5000) {
    const toast: ToastMessage = {
      id: `toast-${++this.toastIdCounter}`,
      type,
      title: title || this.getDefaultTitle(type),
      message,
      duration
    };

    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next([...currentToasts, toast]);
  }

  success(message: string, title?: string, duration?: number) {
    this.show('success', message, title, duration);
  }

  error(message: string, title?: string, duration?: number) {
    this.show('danger', message, title, duration);
  }

  warning(message: string, title?: string, duration?: number) {
    this.show('warning', message, title, duration);
  }

  info(message: string, title?: string, duration?: number) {
    this.show('info', message, title, duration);
  }

  remove(id: string) {
    const currentToasts = this.toastsSubject.value;
    const filteredToasts = currentToasts.filter(toast => toast.id !== id);
    this.toastsSubject.next(filteredToasts);
  }

  clear() {
    this.toastsSubject.next([]);
  }

  private getDefaultTitle(type: string): string {
    switch (type) {
      case 'success':
        return 'Success';
      case 'danger':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'info':
        return 'Info';
      default:
        return 'Notification';
    }
  }
}
